import React, { useEffect, useRef } from 'react';
import { pick } from 'js/utils/ramda.util';
import { require } from 'js/backbone/portlets';
import { AUTH_REDUCER } from 'js/store/constants';
import { useCustomSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';
import { componentService } from 'js/services/component.service';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';

import { CASHIER_IFRAME } from './constants';

class CashierIframeWrapper extends React.Component {
    componentDidMount() {
        this.processPortlet();
    }

    componentDidUpdate(prevProps) {
        const { config } = this.props;

        if (prevProps.config.cashierServiceType !== config.cashierServiceType) {
            this.processPortlet();
        }
    }

    componentWillUnmount() {
        this.view && this.view.close();
    }

    processPortlet = () => {
        require(['portlets_cashier_iframe_cashier_iframe_model'], (Model) => {
            const View = Model.prototype.getView;
            const model = new Model({ config: this.props.config, ...this.props.config }, { parse: true });

            this.view = new View({ model, el: this.el });
            this.view.render();
        });
    };

    render() {
        return <BackboneWrapper el={el => this.el = el} />;
    }
}

const CashierIframeBare = () => {
    const ref = useRef();
    const config = usePortletConfig();
    const { cashierServiceType } = config;
    const cashierServiceTypePrev = usePrevious(cashierServiceType);
    const {
        isLoginInProcess,
        isLogoutInProcess
    } = useCustomSelector(AUTH_REDUCER, pick(['isLoginInProcess', 'isLogoutInProcess']));

    useEffect(() => {
        if (isLoginInProcess || isLogoutInProcess) {
            return;
        }

        if (cashierServiceTypePrev && cashierServiceTypePrev === cashierServiceType) {
            return;
        }

        ref.current?.view?.render({ refresh: true });
    }, [isLoginInProcess, isLogoutInProcess, cashierServiceType, cashierServiceTypePrev]);

    return <CashierIframeWrapper config={config} ref={ref} />;
};

export const CashierIframe = withPortlet()(CashierIframeBare);

componentService.registerPageComponents({ [CASHIER_IFRAME]: CashierIframe });
